import { render } from "./ChickenStarters.vue?vue&type=template&id=1ba5fd87"
import script from "./ChickenStarters.vue?vue&type=script&lang=js"
export * from "./ChickenStarters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__